import React from 'react';
import { Link } from 'react-router-dom';
import "../App.css";

const SocialMediaBtn = ({ socialData, settingData }) => {
  const whatsappLink = `https://api.whatsapp.com/send?phone=${settingData.whatsAppNumber}`;
  return (
    <>
      <div className="floating-action-button">
        <div className="fab-options">
          {socialData.map((item, id) => {
            return (
              <div className="fab-option" key={id}>
                <Link to={item.url} target='_blank'><i className={item.icon}></i></Link>
              </div>
            )
          })}
          <div className="fab-option">
            <Link to={whatsappLink} target='_blank'> <i className="fab fa-whatsapp text-white whatsapp" /></Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default SocialMediaBtn;
